{
  "primary": "#291180",
  "primary400": "#E59E00",
  "primary100": "#996900",
  "primaryForeground": "#ffffff",
  "destructive": "#DD1818",
  "success": "#87ab9b",
  "ink": "#38424B",
  "inkSecondary": "#5F5F5F",
  "muted": "#8E8E93",
  "border": "#E5E5EA",
  "fill": "#F2F2F7",
  "fillInput": "#F5F5F5",
  "surface": "#f2f2f2",
  "borderSurface": "#e0e0e0",
  "accent": "#291180",
  "accentForeground": "#ffffff",
  "warning": "#FFF3CD",
  "warningForeground": "#856404",
  "ctaTint": "#F0F8FF",
  "tipBg": "#E5F1FF",
  "avatarBg": "#E1E1E1",
  "disabled": "#A0A0A0",
  "disabledText": "#FFFFFF",
  "buttonSecondary": "#E0E0E0",
  "secondary700": "#E7E7EF",
  "coreSuccess": "#21874F",
  "coreSecondary": "#8F8CB2",
  "corePink": "#E30B5D",
  "corePrimary": "#FFB104",
  "corePinkFill": "#E30B5D33",
  "corePrimaryFill": "#FFB10433",
  "onboardingSignin": "rgba(0, 0, 0, 0.4)",
  "textHeader": "#050505",
  "textMuted": "#777777",
  "textBody": "#353535",
  "background": "#ffffff",
  "backgroundPrimary": "#F1F1F1",
  "backgroundSecondary": "#FEFBFB",
  "grayMid": "#C6C6C6",
  "errorBackground": "#FFEDEE"
}
